
// Logo affiché dans la popup de partage et sur la page de connexion des utilisateurs.
// Vous pouvez le modifier en changeant l'URL entre les guillemets, ex: const logo = "https://example.com/new-logo.png"
const logo = "https://gapianne.com/cdn/shop/files/logo-gapianne_7a65f4c4-54e8-4831-afa2-0849e4c5f8de.png";

// Textes de partage.
// Le titre sera affiché dans la popup de partage, et le texte sera ajouté avec le lien lors du partage.
const titrePopupPartage = "Prêt(e) à révéler un secret bien-être ?";
const textePartage = "Découvre ce produit chez Gapianne";

// Lien de la page d'accueil de votre site.
const homepage = "https://gapianne.com/";

// Configure de Frak
const frakConfig = {
    walletUrl: "https://wallet.frak.id",
    metadata: {
        name: "Gapianne",
    },
    domain: window.location.host,
};

// Configuration de la modal pour la reception de recompense (a l'ouverture d'un liens de partage)
//  toute les options de configuration sont retrouvables ici: https://docs.frak.id/wallet-sdk/api/types/DisplayModalType
const rewardModalConfig = {
    steps: {
        login: {
            allowSso: true,
            ssoMetadata: {
                logoUrl: logo,
                homepageLink: homepage,
            },
        },
        openSession: {},
        final: {
            action: { key: "reward" },
        },
    },
    metadata: {
        header: { icon: logo },
        isDismissible: true,
        lang: "fr",
    },
};

// Configuration de la modal lors de la creation d'un liens de partage
//  toute les options de configuration sont retrouvables ici: https://docs.frak.id/wallet-sdk/api/types/DisplayModalType
const sharedModalConfig = {
    steps: {
        login: {
            allowSso: true,
            ssoMetadata: {
                logoUrl: logo,
                homepageLink: homepage,
            },
        },
        openSession: {},
        final: {
            action: {
                key: "sharing",
                options: {
                    popupTitle: titrePopupPartage,
                    text: textePartage,
                    link: window.location.href,
                },
            },
        },
    },
    metadata: {
        header: { icon: logo },
        isDismissible: true,
        lang: "fr",
    },
};

// Helper function to display the shared modal
function modalShare() {
    window.NexusSDK.displayModal(
        window.FrakSetup.frakClient,
        sharedModalConfig
    );
}

// Watch the wallet status, and store the wallet token in the session storage, to ensure proper purchase tracking
function watchWalletStatus() {
    const SESSION_STORAGE_KEY = "frak-wallet-interaction-token";
    window.NexusSDK.watchWalletStatus(window.FrakSetup.frakClient, (status) => {
        if (status.key === "connected") {
            sessionStorage.setItem(SESSION_STORAGE_KEY, status.wallet);
        } else {
            sessionStorage.removeItem(SESSION_STORAGE_KEY);
        }
    }).catch(() => {
        sessionStorage.removeItem(SESSION_STORAGE_KEY);
    });
}

// Setup the referral listener on the Frak client
function setupReferral() {
    window.NexusSDK.referralInteraction(window.FrakSetup.frakClient, {
        modalConfig: rewardModalConfig,
    }).then((referral) => {
        console.log("referral result", referral);
    });
}

// Function that will setup the Frak client
function setupFrakClient() {
    return new Promise((resolve) => {
        window.NexusSDK.createIframe({
            walletBaseUrl: frakConfig.walletUrl,
        }).then((iframe) => {
            if (!iframe) {
                console.error("Failed to create Frak iframe");
                resolve(null);
            }

            resolve(
                window.NexusSDK.createIFrameNexusClient({
                    config: frakConfig,
                    iframe,
                })
            );
        });
    });
}

// Expose the Frak setup to the window object
window.FrakSetup = { frakConfig, modalShare };

// On the page load, setup the Frak client and watch the wallet status and referral state
document.addEventListener("DOMContentLoaded", () => {
    setupFrakClient().then((frakClient) => {
        if (!frakClient) {
            console.error("Failed to create Frak client");
            return;
        }

        window.FrakSetup.frakClient = frakClient;

        // Once loaded, watch the wallet status and the referral state
        watchWalletStatus();
        setupReferral();
    });
});